import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  root: {
    padding: '12px 24px',
    borderTop: `1px solid ${theme.palette.active[50]}`,
  },
});

const SectionFooter = ({
  classes, children, justify,
}) => (
  <Grid
    className={classes.root}
    component="footer"
    container
    justify={justify}
    spacing={0}
    alignItems="center"
  >
    {children}
  </Grid>
);

SectionFooter.propTypes = {
  justify: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

SectionFooter.defaultProps = {
  justify: 'center',
};

export default withStyles(styles)(SectionFooter);



// WEBPACK FOOTER //
// ./src/components/common/Section/SectionFooter.js